export function coerceUndefinedToNull<T>(x: T | undefined): T | null {
    if (x === undefined) {
        return null;
    }
    return x;
}
